<template>
    <div>
        <GenericPopups ref="GenericPopups"></GenericPopups>


        <b-table id="fulfillment-results" ref="fulfillmentResults" striped hover borderless
                 show-empty
                 selectable
                 select-mode="single"
                 :tbody-tr-class="rowClass"
                 head-variant="dark"
                 primary-key="order_id"
                 :busy="isBusy"
                 :fields="fields"
                 :items="_filteredList"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 @row-selected="onRowSelected">
            <template v-slot:head(selected)="row">
                <b-button size="sm" variant="outline-light" :pressed.sync="allSelected">
                    <i class="fa-regular fa-check fa-fw"></i>
                </b-button>
            </template>
            <template v-slot:cell(order.id)="data">
                <b-button variant="link" class="my-0 py-0" :to="'/kit/view/'+ data.item.order.id">{{
                        data.item.order.id
                    }}
                </b-button>
            </template>
            <template v-slot:cell(name)="data">
                {{ data.item.customer.first_name }} {{ data.item.customer.last_name }}
            </template>
            <template v-slot:cell(requested_at)="data">
                {{ data.item.requested_at | datetime }}
            </template>
            <template v-slot:cell(open_requests)="data">
                {{ getCountOfLeads(data.item) }}
            </template>
            <template v-slot:cell(review_reason)="data">
                {{ data.item.status | titleCase }}
                <div title="Invalid Address" v-if="data.item.review_reason === 'invalid-address'"><i
                    class="fa-solid fa-map-marker-alt-slash"></i></div>
                <div title="Multiple Leads" v-if="data.item.review_reason === 'multiple-leads'"><i
                    class="fa-solid fa-cubes"></i>
                </div>
            </template>
            <template v-slot:cell(show_details)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                    {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                </b-button>
            </template>

            <template v-slot:row-details="row">
                <b-card class="text-left">
                    <b-row>
                        <b-col cols="5">
                            <b-row class="mb-2">
                                <b-col class="text-sm-right">Review Reason:</b-col>
                                <b-col class="font-weight-bold">{{
                                        row.item.review_reason | titleCase
                                    }}
                                </b-col>
                            </b-row>

                            <b-row v-if="row.item.review_reason === 'invalid-address' && row.item.customer.address.verification_messages && row.item.customer.address.verification_messages.length > 0">
                                <b-col>
                                    <b-card no-body class="mb-2" body-class="py-2">
                                        <b-card-header v-b-toggle.address-messages class="p-1">
                                            <i class="fa-solid fa-exclamation-triangle fa-xs mr-1"></i> <span class="label">Address Verification Alerts</span>
                                        </b-card-header>
                                        <b-collapse visible id="address-messages">
                                            <b-card-body class="p-2">
                                                <b-card-text>
                                                    <div v-for="item in row.item.customer.address.verification_messages" :key="item.code">
                                                        <div>
                                                            <i v-if="item.type == 'address_error'" class="fa-solid fa-circle-x text-danger fa-xs mr-1"></i>
                                                            <i v-else-if="item.type == 'address_correction'" class="fa-solid text-info fa-edit fa-xs mr-1"></i>
                                                            <i v-else class="fa-solid fa-exclamation-triangle text-warning fa-xs mr-1"></i>
                                                            <span class="font-xs"><small class="font-weight-bold">{{ item.code || 'Business Rules'}}</small></span>
                                                        </div>
                                                        <div class="font-xs" style="line-height: normal;"><small>{{ item.text }}</small></div>
                                                    </div>
                                                </b-card-text>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col v-if="row.item.review_reason === 'invalid-address'">
                            <b-form class="w-100">
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="input-group-1"
                                            label="Address 1:"
                                            label-for="input-1"
                                        >
                                            <b-form-input
                                                id="address1"
                                                v-model="row.item.customer.address.address1"
                                                required
                                                placeholder="Enter Address"
                                                size="sm"
                                            ></b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-2" label="Address 2:"
                                                      label-for="input-2">
                                            <b-form-input
                                                id="input-2"
                                                v-model="row.item.customer.address.address2"
                                                size="sm"
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>

                                </b-form-row>

                                <b-form-row>
                                    <b-col>

                                        <b-form-group id="input-group-3" label="City:"
                                                      label-for="input-3">
                                            <b-form-input
                                                id="input-3"
                                                v-model="row.item.customer.address.city"
                                                required
                                                size="sm"
                                            ></b-form-input>
                                        </b-form-group>

                                    </b-col>

                                    <b-col>
                                        <b-form-group
                                            label="State:"
                                            label-for="input-4"
                                        >
                                            <input type="hidden" v-model="row.item.customer.address.state">
                                            <multiselect v-model="row.item.customer.address.stateModel"
                                                         id="input-4"
                                                         @input="stateChanged(row)"
                                                         :options="US_STATES_LIST"
                                                         :optionHeight="8"
                                                         group-values="types"
                                                         group-label="name"
                                                         :searchable="true"
                                                         :close-on-select="true"
                                                         :show-labels="false"
                                                         :group-select="false"
                                                         track-by="id"
                                                         label="name"
                                                         placeholder="Select State">

                                            </multiselect>
                                        </b-form-group>


                                        <!--<b-form-group id="input-group-4" label="State:"-->
                                        <!--label-for="input-3">-->
                                        <!--<b-form-input-->
                                        <!--id="input-4"-->
                                        <!--v-model="row.item.customer.address.state"-->
                                        <!--required-->
                                        <!--size="sm"-->
                                        <!--&gt;</b-form-input>-->
                                        <!--</b-form-group>-->
                                    </b-col>

                                    <b-col>

                                        <b-form-group id="input-group-5" label="Zip:"
                                                      label-for="input-3">
                                            <b-form-input
                                                id="input-5"
                                                v-model="row.item.customer.address.zip"
                                                required
                                                size="sm"
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>

                                <b-button variant="primary" :disabled="working"
                                          @click="updateAddress(row)" class="mr-2"><i
                                    class="fa-solid fa-redo fa-fw"></i> Update Address
                                </b-button>
                                <b-button variant="secondary" :disabled="working"
                                          @click="markDoNotPrintSelected(row.item)" class="mr-2"><i
                                    class="fa-solid fa-chevron-right fa-fw"></i> Can't Resolve
                                </b-button>


                                <NotesModule :variant="'danger'" :order_id="row.item.order.id"
                                             :customer_id="row.item.customer.id" user="user"></NotesModule>


                                <b-button variant="info"
                                          :id="'flags_' + row.index"
                                          class="mr-2">
                                    <i class="fa-regular fa-flag fa-lg fa-fw"></i>
                                </b-button>

                                <b-popover id="flag-popover"
                                           :target="'flags_' + row.index" title="Flags"
                                           triggers="click blur"
                                           placement="bottom">
                                    <template #title>
                                        <b-form-row>
                                            <b-col>Flags</b-col>
                                            <b-col cols="8">
                                                <b-button @click="addFlag(row.item.order)"
                                                          class="float-right"
                                                          size="sm">
                                                    <i class="fa-regular fa-plus"></i> Add Flag
                                                </b-button>
                                            </b-col>
                                        </b-form-row>

                                    </template>
                                    <b-list-group flush class="set-height">
                                        <b-list-group-item href="#"
                                                           class="flex-column align-items-start p-0"
                                                           v-for="(flag, index) in non_cleared_flags(row)"
                                                           :key="index">
                                            <h5 class="mb-1 text-center" @click="editFlag(row.item.order, flag)">
                                                <b-badge :variant="getVariant(flag.flag_type.config)"
                                                         v-b-tooltip.hover
                                                         :title="flag.note" pill>{{ flag.flag_type.abbreviations }}
                                                </b-badge>
                                            </h5>
                                        </b-list-group-item>
                                    </b-list-group>
                                </b-popover>


                            </b-form>
                        </b-col>

                        <b-col v-if="row.item.review_reason === 'multiple-leads'">
                            <b-table-lite small :fields="reviewTableFields"
                                          :items="row.item.order.leads" :tbody-tr-class="getLeadDisplay">
                                <template v-slot:cell(action)="data">
                                    <b-form-checkbox v-model="data.item.selected" name="check-button">
                                    </b-form-checkbox>
                                </template>
                                <template v-slot:cell(created_at)="data">
                                    {{ data.item.created_at | datetime }}
                                </template>
                                <template v-slot:cell(status)="data">
                                    {{ data.item.status | capitalize }}
                                </template>
                            </b-table-lite>

                            <b-button variant="warning" class="mr-2" :disabled="working"
                                      @click="markIgnore(row.item)"><i
                                class="fa-solid fa-print-slash fa-fw"></i> Mark as Ignored
                            </b-button>
                            <b-button variant="success" class="mr-2" :disabled="working"
                                      @click="markPrint(row.item)"><i
                                class="fa-solid fa-check fa-fw"></i> Mark as
                                Ready To Print
                            </b-button>

                            <NotesModule :variant="'info'" :order_id="row.item.order.id"
                                         :customer_id="row.item.customer.id" user="user"></NotesModule>

                            <!--WILL DELETE ONCE APPROVED - A.MCKEE-->
                            <!--<b-button variant="info" :id="'notes_' + row.index" class="mr-2"><i-->
                            <!--class="fa-regular fa-clipboard-list fa-lg fa-fw"></i>-->
                            <!--</b-button>-->


                            <!--<b-popover :target="'notes_' + row.index" title="Notes" triggers="click blur" placement="bottom">-->
                            <!--<b-list-group flush style="height: auto; max-height: 300px; overflow: scroll;">-->
                            <!--<b-list-group-item class="flex-column align-items-start p-0" v-for="(note, index) in row.item.order.notes" :key="index">-->
                            <!--<div class="d-flex w-100 justify-content-between">-->
                            <!--<h6 class="mb-1">{{ note.creator_name || 'System' }}</h6>-->
                            <!--</div>-->

                            <!--<p class="mb-1">-->
                            <!--{{ note.contents }}-->
                            <!--</p>-->

                            <!--<small>{{ note.created_at | date }} {{ note.created_at | time }}</small>-->
                            <!--</b-list-group-item>-->
                            <!--</b-list-group>-->
                            <!--</b-popover>-->
                            <!--WILL DELETE ONCE APPROVED - A.MCKEE-->


                            <b-button variant="info"
                                      :id="'flags_' + row.index"
                                      class="mr-2">
                                <i class="fa-regular fa-flag fa-lg fa-fw"></i>
                            </b-button>
                            <b-button variant="success" class="mr-2" :disabled="row.item.working"
                                      @click="saveReviewDecisions(row.item)">
                                <i v-if="row.item.working" class="fa-solid fa-spinner fa-spin"></i>
                                <i v-else class="fa-solid fa-check fa-fw"></i> Save
                            </b-button>

                            <b-popover id="flag-popover"
                                       :target="'flags_' + row.index" title="Flags"
                                       triggers="click blur"
                                       placement="bottom">
                                <template #title>
                                    <b-form-row>
                                        <b-col>Flags</b-col>
                                        <b-col cols="8">
                                            <b-button @click="addFlag(row.item.order)"
                                                      class="float-right"
                                                      size="sm">
                                                <i class="fa-regular fa-plus"></i> Add Flag
                                            </b-button>
                                        </b-col>
                                    </b-form-row>

                                </template>
                                <b-list-group flush class="set-height">
                                    <b-list-group-item href="#"
                                                       class="flex-column align-items-start p-0"
                                                       v-for="(flag, index) in non_cleared_flags(row)"
                                                       :key="index">
                                        <h5 class="mb-1 text-center" @click="editFlag(row.item.order, flag)">
                                            <b-badge :variant="getVariant(flag.flag_type.config)"
                                                     v-b-tooltip.hover
                                                     :title="flag.note" pill>{{ flag.flag_type.abbreviations }}
                                            </b-badge>
                                        </h5>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-popover>

                        </b-col>

                        <b-col v-if="row.item.status == 'system-hold' && !row.item.review_reason">

                            <b-button variant="warning" class="mr-2" :disabled="working"
                                      @click="markAsIgnored(row.item)"><i
                                class="fa-solid fa-print-slash fa-fw"></i> Mark as Ignored
                            </b-button>
                            <b-button variant="success" class="mr-2" :disabled="working"
                                      @click="markPrintSelected(row.item)"><i
                                class="fa-solid fa-check fa-fw"></i> Mark as
                                Ready To Print
                            </b-button>

                            <NotesModule :variant="'info'" :order_id="row.item.order.id"
                                         :customer_id="row.item.customer.id" user="user"></NotesModule>

                            <!--WILL DELETE ONCE APPROVED - A.MCKEE-->
                            <!--<b-button variant="info" :id="'notes_' + row.index" class="mr-2"><i-->
                            <!--class="fa-regular fa-clipboard-list fa-lg fa-fw"></i>-->
                            <!--</b-button>-->


                            <!--<b-popover :target="'notes_' + row.index" title="Notes" triggers="click blur" placement="bottom">-->
                            <!--<b-list-group flush style="height: auto; max-height: 300px; overflow: scroll;">-->
                            <!--<b-list-group-item class="flex-column align-items-start p-0" v-for="(note, index) in row.item.order.notes" :key="index">-->
                            <!--<div class="d-flex w-100 justify-content-between">-->
                            <!--<h6 class="mb-1">{{ note.creator_name || 'System' }}</h6>-->
                            <!--</div>-->

                            <!--<p class="mb-1">-->
                            <!--{{ note.contents }}-->
                            <!--</p>-->

                            <!--<small>{{ note.created_at | date }} {{ note.created_at | time }}</small>-->
                            <!--</b-list-group-item>-->
                            <!--</b-list-group>-->
                            <!--</b-popover>-->
                            <!--WILL DELETE ONCE APPROVED - A.MCKEE-->


                            <b-button variant="info"
                                      :id="'flags_' + row.index"
                                      class="mr-2">
                                <i class="fa-regular fa-flag fa-lg fa-fw"></i>
                            </b-button>
                            <!-- <b-button variant="success" class="mr-2" :disabled="row.item.working"
                                      @click="saveReviewDecisions(row.item)">
                                <i v-if="row.item.working" class="fa-solid fa-spinner fa-spin"></i>
                                <i v-else class="fa-solid fa-check fa-fw"></i> Save
                            </b-button> -->

                            <b-popover id="flag-popover"
                                       :target="'flags_' + row.index" title="Flags"
                                       triggers="click blur"
                                       placement="bottom">
                                <template #title>
                                    <b-form-row>
                                        <b-col>Flags</b-col>
                                        <b-col cols="8">
                                            <b-button @click="addFlag(row.item.order)"
                                                      class="float-right"
                                                      size="sm">
                                                <i class="fa-regular fa-plus"></i> Add Flag
                                            </b-button>
                                        </b-col>
                                    </b-form-row>

                                </template>
                                <b-list-group flush class="set-height">
                                    <b-list-group-item href="#"
                                                       class="flex-column align-items-start p-0"
                                                       v-for="(flag, index) in non_cleared_flags(row)"
                                                       :key="index">
                                        <h5 class="mb-1 text-center" @click="editFlag(row.item.order, flag)">
                                            <b-badge :variant="getVariant(flag.flag_type.config)"
                                                     v-b-tooltip.hover
                                                     :title="flag.note" pill>{{ flag.flag_type.abbreviations }}
                                            </b-badge>
                                        </h5>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-popover>

                        </b-col>
                    </b-row>
                </b-card>
            </template>


            <template v-slot:table-busy>
                <LoadingSpinner :busy="isBusy"/>
            </template>
        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="fulfillment-results"
            align="center"
            size="sm"
        ></b-pagination>
    </div>
</template>

<script>
import NotesModule from '../../components/NotesPopupFullfilment';
import Lead from '@/models/Lead';
import LoadingSpinner from '../../components/LoadingSpinner';
import GenericPopups from '../../components/GenericPopups';
import Multiselect from 'vue-multiselect';

export default {
    name: 'fulfillment-review',
    components: {
        Multiselect,
        LoadingSpinner,
        NotesModule,
        GenericPopups: GenericPopups,
    },
    data() {
        return {
            notesOpen: true,
            notes: {
                customer_id: null,
                order_id: null,
            },
            perPage: 25,
            currentPage: 1,
            isBusy: false,
            working: false,
            sortBy: 'requested_at',
            sortDesc: false,
            filterSearch: null,
            filter: '',
            fields: [
                {key: 'order.id', label: 'Order #', class: 'text-center', sortable: true},
                {key: 'customer.id', label: 'Customer #', class: 'text-center', sortable: true},
                {key: 'requested_at', label: 'Request Date', class: 'text-center', sortable: true},
                {key: 'name', class: 'text-center', sortable: false},
                {key: 'brand.name', label: 'Brand', class: 'text-center', sortable: true},
                {key: 'open_requests', class: 'text-center', sortable: true},
                {key: 'review_reason', label: 'Status', class: 'text-center', sortable: true},
                'show_details'
            ],
            items: [],
            selected: [],
            allSelected: false,
            reviewTableFields: [
                {key: 'action', label: ''},
                {key: 'id', label: 'Lead Id'},
                {key: 'created_at', label: 'Created Date'},
                {key: 'status', label: 'Print Status'}
            ],
            showCompleteModal: null,
            targetOrder: null,
            targetPosition: null,
        };
    },
    computed: {
        _filteredList() {
            let filterValue = this.filterSearch;
            if (filterValue != null && filterValue != '') {
                filterValue = filterValue.toLowerCase();
                return this.items.filter(item => item.customer.first_name.toLowerCase().includes(filterValue) ||
                    item.customer.last_name.toLowerCase().includes(filterValue) ||
                    item.order.id.toString().includes(filterValue) ||
                    item.customer.id.toString().includes(filterValue));
            } else {
                return this.items.filter(item => item);
            }
        },
        totalRows: function () {
            return this.items.length;
        },
        disableActions: function () {
            return this.selected.length <= 0;
        },
        _isFlagUpdated() {
            return this.$store.getters.updatedFlag;
        }
    },
    created() {
        this.refreshData();
    },
    methods: {
        stateChanged(item) {
            this.items[item.index].customer.address.state = this.items[item.index].customer.address.stateModel.id;
        },
        getNotesData(item) {
            console.log(item);
        },
        non_cleared_flags: function (row) {
            return _.filter(row.item.order.flags, (e) => {
                return e.cleared_at == null;
            });
        },
        fetchData(page = 1) {
            let vm = this;

            let promise = new Promise((resolve) => {
                let response = Lead
                    .include(['customer', 'order.brand', 'order', 'customer.orders', 'order.notes', 'order.leads'])
                    .where('status', 'review')
                    .orderBy((vm.sortDesc ? '-' : '') + vm.sortBy)
                    .page(page)
                    .limit(vm.perPage)
                    .get();

                resolve(response);
            });

            return promise.then(response => {
                let items = response.data;

                // load additional paginated items
                if (response.next_page_url !== null) {
                    return vm.fetchData(++page).then((nItems) => {
                        return items.concat(nItems);
                    });
                }

                return items;
            });
        },
        refreshData() {
            let vm = this;

            vm.isBusy = true;

            this.$emit('refresh');

            vm.fetchData().then((items) => {
                vm.items = items;
                vm.items.forEach(function (item) {
                    if (item.customer.address.state) {
                        let localState = vm.US_STATES_LIST[0].types.filter(state => item.customer.address.state.toUpperCase() == state.id.toUpperCase());
                        if (localState && localState[0]) {
                            vm.$set(item.customer.address, 'stateModel', {id: localState[0].id, name: localState[0].name});
                        }
                    }
                });
                vm.isBusy = false;
            });
        },
        onRowSelected(items) {
            this.selected = items;
            if (items.length === 0) {
                this.allSelected = false;
            }
        },
        selectAllRows() {
            this.$refs.fulfillmentResults.selectAllRows();
        },
        clearSelected() {
            this.$refs.fulfillmentResults.clearSelected();
        },
        clearFilter() {
            this.filter = '';
        },
        addFlag(order) {
            this.$nextTick(function () {
                console.log(order, 'flag');
                this.targetOrder = order.id;
                this.targetPosition = order.flags.length;
                //this.$store.commit('setActiveOrder', {id: order.id});
                this.$store.commit('setAddFlag', order.id);
            });

        },
        editFlag(order, flag) {
            this.targetOrder = order.id;
            this.targetPosition = _.findIndex(order.flags, (e) => {
                return e.id == flag.id;
            });
            //this.$store.commit('setActiveOrder', {id: order.id});
            this.$store.commit('setActiveFlag', flag);
        },
        updateFlag(flag) {
            _.forEach(this.items, (e) => {
                console.log('checkme', e.order.id, this.targetOrder);
                if (e.order.id == this.targetOrder) {
                    console.log('pass', e.order.id, this.targetOrder);
                    e.order.flags[this.targetPosition] = flag;
                }
            });
            this.$forceUpdate();
        },

        getVariant(config) {
            if (config) {
                let decodedConfig = JSON.parse(config);
                return decodedConfig.variant ? decodedConfig.variant : 'secondary';
            }
            return 'secondary';
        },
        markDoNotPrintSelected(item) {
            this.working = true;
            let vm = this;
            item.status = 'do-not-print';
            let lead = new Lead({id: item.id});
            lead.markDoNotPrint().then(() => {
                setTimeout(() => {
                        vm.items = vm.items.filter((elem) => {
                            return elem !== item;
                        });
                    }, 1000
                );
                this.working = false;
                this.$bvToast.toast('Success. Lead ' + item.id + ' has an updated print status of "Do Not Print". ',
                    {toaster: 'b-toaster-top-center', title: 'Success'});
            });
        },
        markAsIgnored(item) {
            this.working = true;
            let vm = this;
            item.status = 'ignore-print';
            let lead = new Lead({id: item.id});
            lead.markIgnored().then(() => {
                setTimeout(() => {
                        vm.items = vm.items.filter((elem) => {
                            return elem !== item;
                        });
                    }, 1000
                );
                this.working = false;
                this.$bvToast.toast('Success. Lead ' + item.id + ' has an updated print status of "Ignored". ',
                    {toaster: 'b-toaster-top-center', title: 'Success'});
            });
        },
        markPrintSelected(item) {
            this._markPrintSelected(item);
            this.$bvToast.toast('Success. Lead ' + item.id + ' has an updated print status of "Ready".',
                {toaster: 'b-toaster-top-center', title: 'Success'});
        },
        markDoNotPrint(item) {
            _.forEach(item.order.leads, (e) => {
                if (e.selected) {
                    e.status = 'do-not-print';
                }
            });
        },
        markIgnore(item) {
            _.forEach(item.order.leads, (e) => {
                if (e.selected) {
                    e.status = 'ignore-print';
                }
            });
        },
        markPrint(item) {
            _.forEach(item.order.leads, (e) => {
                if (e.selected) {
                    e.status = 'ready';
                }
            });
        },
        saveReviewDecisions(item) {
            item.working = true;
            this.$forceUpdate();
            let vm = this;
            let discard = true;
            let leads = [];
            _.forEach(item.order.leads, (e) => {
                leads.push({
                    id: e.id,
                    status: e.status,
                });
                if (e.status == 'review') {
                    discard = false;
                }
            });
            this.$http.post('/leads/statusUpdate', {
                leads: leads
            }).then((e) => {
                item.working = false;
                vm.$forceUpdate();
                if (discard) {
                    setTimeout(() => {
                            vm.items = vm.items.filter((elem) => {
                                return elem !== item;
                            });
                        }, 1000
                    );
                }
                this.$bvToast.toast('Success. Order ' + item.order.id + ' has been updated.',
                    {toaster: 'b-toaster-top-center', title: 'Success'});
                this.working = false;
            });
        },
        _markPrintSelected(item) {
            this.working = true;
            let vm = this;
            item.status = 'ready';
            let lead = new Lead({id: item.id});
            lead.markReadyToPrint().then(() => {
                setTimeout(() => {
                        vm.items = vm.items.filter((elem) => {
                            return elem !== item;
                        });
                    }, 1000
                );
                this.working = false;
            });
        },
        _markReviewForMutlipleLeads(item) {
            this.working = true;
            let vm = this;
            item.status = 'review';
            item.review_reason = 'multiple-leads';
            let lead = new Lead({id: item.id});
            lead.markForReveiwMultipleLeads().then(() => {
                this.working = false;
            });
        },
        updateAddress(item) {
            this.working = true;
            let address = item.item.customer.address;
            address.created_at = null;
            address.updated_at = null;
            address.verified = null;
            address.force_verify = true;
            this.$http.post('/leads/updateAddress/' + address.id, address).then((response) => {
                if (response.data.data.verified === true) {
                    _.forEach(this.items, (row) => {
                        if (row.customer.id == item.item.customer.id) {
                            this.working = false;
                            if (this.getCountOfLeads(row) > 2) {
                                this._markReviewForMutlipleLeads(row);
                                if (row.id == item.item.id) {
                                    this.$bvToast.toast('Success. The address has been updated, however, it has multiple leads and needs further review.',
                                        {toaster: 'b-toaster-top-center', title: 'Success'});
                                }
                            } else {
                                this._markPrintSelected(row);
                                if (row.id == item.item.id) {
                                    this.$bvToast.toast('Success. The address has been updated.',
                                        {
                                            toaster: 'b-toaster-top-center',
                                            solid: true,
                                            title: 'Success'
                                        });
                                }
                            }
                        }
                    });
                } else {
                    this.working = false;
                    let messages = JSON.parse(response.data.data.verification_messages);
                    this.$bvToast.toast(messages[0].text, {
                        title: messages[0].code,
                        toaster: 'b-toaster-top-center',
                        solid: true,
                    });
                }
            });
        },

        getCountOfLeads(item) {
            return item.order.leads.length;
        },
        closeFulfillment() {
            this.showCompleteModal = true;
        },
        handleCompleteOk() {
            this.$http.get('fulfillment/finished_report');
        },
        rowClass(item, type) {
            if (!item) return;
            if (item.status === 'ready') return 'text-center table-success';
            if (item.status === 'do-not-print') return 'text-center table-warning';
            return 'text-center';
        },
        getLeadDisplay(lead) {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].id == lead.id) {
                    return 'table-warning';
                }
            }
            return '';
        },
    },
    watch: {
        _isFlagUpdated: {
            immediate: true,
            deep: true,
            handler(flag) {
                if (this.items && this.items.length > 0) {
                    this.updateFlag(flag);
                }
            }
        },
        allSelected: function (val) {
            if (val === true) {
                this.selectAllRows();
            } else {
                this.clearSelected();
            }
        },
    }
};
</script>
<style>
#flag-popover {
    min-width: 200px !important;
}
</style>
<style scoped>

</style>
